module.exports = __webpack_public_path__ + "static/media/TankYou-v2.59176986.png";